// Lazy chart boundary (KOA-18066). Pages import ONLY from this file (and
// chart-types) — never raw recharts — so the library stays swappable and the
// dynamic import marks a real code-split point.
//
// NOTE on bundling reality: the designer's rsbuild splitChunks strategy
// (enforce'd path-based cacheGroups + a top-level `name: "shared"` catch-all in
// rsbuild/performance-config.ts) currently absorbs EVERY async chunk into the
// eager named chunks — the same happens to the router's React.lazy(UiKitLab).
// So recharts practically ships inside `shared` today (~100KB gz on a ~12.6MB
// gz total). The boundary is still correct: if the global chunk strategy ever
// honors async chunks, this split materializes with zero code changes.
import * as React from "react";
import type { ModelMixChartProps, TrendChartProps } from "./chart-types";

const TrendChartInner = React.lazy(() => import(/* webpackChunkName: "aichat-charts" */ "./trend-chart"));
const ModelMixChartInner = React.lazy(() => import(/* webpackChunkName: "aichat-charts" */ "./model-mix-chart"));

interface ChartSkeletonProps {
  height: number;
}

/** Fixed-height skeleton so the lazy swap causes no layout shift. */
function ChartSkeleton({ height }: ChartSkeletonProps): React.ReactElement {
  return <div className="aichat-analytics__chart-skeleton" style={{ height }} aria-hidden="true" />;
}

export function LazyTrendChart(props: TrendChartProps): React.ReactElement {
  return (
    <React.Suspense fallback={<ChartSkeleton height={props.height ?? 220} />}>
      <TrendChartInner {...props} />
    </React.Suspense>
  );
}

export function LazyModelMixChart(props: ModelMixChartProps): React.ReactElement {
  return (
    <React.Suspense fallback={<ChartSkeleton height={props.size ?? 180} />}>
      <ModelMixChartInner {...props} />
    </React.Suspense>
  );
}
